"use client";

import { Download, FileJson, UserX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { confirmDialog } from "@/components/ui/confirm";
import { toast } from "@/components/ui/toast";

export function DatenschutzAktionen({ name }: { name: string }) {
  return (
    <div className="space-y-3">
      <div>
        <Button variant="outline" className="w-full justify-start" onClick={() => toast.success("Auskunft wird erstellt — PDF folgt")}>
          <Download className="h-4 w-4" aria-hidden />
          Auskunft als PDF (Art. 15)
        </Button>
        <p className="text-caption text-text-tertiary mt-1">Alle gespeicherten Daten, Zwecke und Empfänger.</p>
      </div>
      <div>
        {/* BACKEND: Export aller Daten der Person als JSON/CSV (Art. 20 Datenuebertragbarkeit). */}
        <Button variant="outline" className="w-full justify-start" onClick={() => toast.success("Export wird vorbereitet")}>
          <FileJson className="h-4 w-4" aria-hidden />
          Daten mitnehmen (Art. 20)
        </Button>
        <p className="text-caption text-text-tertiary mt-1">Maschinenlesbar, zum Mitnehmen in eine andere Software.</p>
      </div>
      <div>
        <Button
          variant="ghost"
          className="text-danger w-full justify-start"
          onClick={async () => {
            const ok = await confirmDialog({
              title: `Daten von ${name} löschen?`,
              description: "Belege und Buchungen bleiben für die gesetzliche Aufbewahrungsfrist anonymisiert erhalten. Alles andere wird entfernt.",
              confirmLabel: "Löschen",
              danger: true,
            });
            if (ok) toast.success("Löschung vorgemerkt");
          }}
        >
          <UserX className="h-4 w-4" aria-hidden />
          Löschen (Art. 17)
        </Button>
      </div>
    </div>
  );
}
